import React, { useRef } from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { FileText, Target, Users, Palette } from 'lucide-react';
import { services } from '../mockData';

gsap.registerPlugin(ScrollTrigger, useGSAP);

const iconMap = {
  FileText: FileText,
  Target: Target,
  Users: Users,
  Palette: Palette
};

export default function ServicesSection() {
  const container = useRef();
  const headerRef = useRef();
  const cardsRef = useRef([]);

  useGSAP(() => {
    gsap.from(headerRef.current, {
      opacity: 0,
      y: 40,
      duration: 0.8,
      scrollTrigger: {
        trigger: container.current,
        start: "top 70%",
        end: "top 30%",
        scrub: 0.5,
      }
    });

    cardsRef.current.forEach((card, index) => {
      if (card) {
        gsap.from(card, {
          opacity: 0,
          y: 60,
          duration: 0.8,
          scrollTrigger: {
            trigger: card,
            start: "top 85%",
            end: "top 40%",
            scrub: 0.5,
          }
        });
      }
    });
  }, { scope: container });

  return (
    <section id="services" ref={container} className="section section-light">
      <div className="section-content">
        <div ref={headerRef} className="section-header">
          <div className="section-eyebrow">What We Do</div>
          <h2 className="section-title">End-to-End Proposal Services</h2>
          <p className="section-description">
            Comprehensive support across the entire proposal lifecycle, from capture strategy through final submission and beyond.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div 
                key={service.id}
                ref={(el) => cardsRef.current[index] = el}
                className="service-card"
              >
                <div className="service-icon">
                  <IconComponent size={28} />
                </div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
